import { createElement } from 'react';
import { createRoot } from 'react-dom/client';
import { flushSync } from 'react-dom';
import type { CpmBoostAdPreviewsDto } from '@zg-rentals/ts-customer-analytics-client';
import {
  DfpPreviewCustomFlag,
  DfpPreviewInFeed,
  DfpPreviewInFeedInternal,
  DfpPreviewSrpNative,
} from '@zg-rentals/rental-revenue-components';

export const renderBoostPreviewOffscreen = async (previewData: CpmBoostAdPreviewsDto): Promise<HTMLDivElement> => {
  const container = document.createElement('div');
  container.style.position = 'absolute';
  container.style.left = '-9999px';
  container.style.top = '0';
  container.style.width = '400px';
  container.style.backgroundColor = '#ffffff';
  container.style.padding = '16px';

  const { dfpPreview } = previewData;
  if (!dfpPreview?.creativeTemplateType) return container;

  const props = { templateValues: dfpPreview.templateValues };
  let component;

  switch (dfpPreview.creativeTemplateType) {
    case 'IN_FEED':
      component = createElement(DfpPreviewInFeed, props);
      break;
    case 'IN_FEED_INTERNAL':
      component = createElement(DfpPreviewInFeedInternal, props);
      break;
    case 'CUSTOM_FLAG':
      component = createElement(DfpPreviewCustomFlag, props);
      break;
    case 'SRP_NATIVE':
      component = createElement(DfpPreviewSrpNative, props);
      break;
    default:
      component = createElement(DfpPreviewSrpNative, props);
  }

  document.body.appendChild(container);
  const root = createRoot(container);
  flushSync(() => {
    root.render(component);
  });

  await new Promise((resolve) => requestAnimationFrame(resolve));

  return container;
};
